import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useState } from 'react'
import { Button } from 'react-bootstrap'
import {
  AuthTypeSelect,
  DefaultCheckbox,
  DynamicFields,
  NameInput,
  PlatformSelect,
  SubmitErrors,
} from '~/dashboard/aws_credentials_form/aws_credentials_form_fields'

export default function AWSCredentialsForm({ onSubmit, errors }) {
  const [name, setName] = useState('')
  const [platform, setPlatform] = useState('')
  const [authType, setAuthType] = useState('')
  const [authMethod, setAuthMethod] = useState('')
  const [authFields, setAuthFields] = useState({})
  const [isDefault, setIsDefault] = useState(false)
  const [formErrors, setFormErrors] = useState({})

  const handleNameChange = (e) => {
    setName(e.target.value)

    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors }
      delete newErrors.name
      return newErrors
    })
  }

  const handlePlatformChange = (_name, value) => {
    setPlatform(value)
    setAuthType('')
    setAuthMethod('')
    setAuthFields({})

    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors }
      delete newErrors.platform
      return newErrors
    })
  }

  const handleAuthTypeChange = (_name, value) => {
    setAuthType(value)
    setAuthMethod('')
    setAuthFields({})

    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors }
      delete newErrors.authType
      return newErrors
    })
  }

  const handleAuthMethodChange = (_name, value) => {
    setAuthMethod(value)
    setAuthFields({})

    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors }
      delete newErrors.authMethod
      return newErrors
    })
  }

  const handleAuthFieldsChange = (e) => {
    const { id, value } = e.target

    setAuthFields((prevAuthFields) => ({
      ...prevAuthFields,
      [id]: value,
    }))
  }

  const validateForm = () => {
    const errors = {}

    if (!name) {
      errors.name = t`Name is required`
    }

    if (!platform) {
      errors.platform = t`Platform is required`
    }

    if (!authType) {
      errors.authType = t`Auth Type is required`
    }

    if (platform === 'windows' && authType === 'winrm' && !authMethod) {
      errors.authMethod = t`Auth Method is required`
    }

    // Dynamic fields validation based on auth type
    switch (authType) {
      case 'ssm':
        if (!authFields.role) errors.role = t`Role is required`
        if (!authFields.region) errors.region = t`Region is required`
        if (!authFields.s3Bucket) errors.s3Bucket = t`S3 Bucket Name is required`
        break
      case 'ssh':
        if (!authFields.username) errors.username = t`Username is required`
        if (!authFields.privateKey) errors.privateKey = t`Private Key is required`
        break
      case 'winrm':
        if (authMethod === 'basic') {
          if (!authFields.username) errors.username = t`Username is required`
          if (!authFields.password) errors.password = t`Password is required`
        } else if (authMethod === 'certificate') {
          if (!authFields.username) errors.username = t`Username is required`
          if (!authFields.privateKey) errors.privateKey = t`Private Key is required`
        }
        break
    }

    setFormErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    if (validateForm()) {
      const payload = {
        name,
        platform,
        auth_type: authType,
        auth_method: authMethod,
        auth_fields: JSON.stringify(authFields),
        is_default: isDefault,
      }

      onSubmit(payload)
    }
  }

  return (
    <>
      {SubmitErrors(errors)}

      <NameInput name={name} handleNameChange={handleNameChange} errors={formErrors} />

      <PlatformSelect platform={platform} handlePlatformChange={handlePlatformChange} error={formErrors.platform} />

      {platform && (
        <AuthTypeSelect
          authType={authType}
          platform={platform}
          handleAuthTypeChange={handleAuthTypeChange}
          error={formErrors.authType}
        />
      )}

      {platform && authType && (
        <DynamicFields
          authType={authType}
          authMethod={authMethod}
          platform={platform}
          authFields={authFields}
          handleAuthFieldsChange={handleAuthFieldsChange}
          handleAuthMethodChange={handleAuthMethodChange}
          errors={formErrors}
        />
      )}

      <DefaultCheckbox isDefault={isDefault} setIsDefault={setIsDefault} />

      <Button formTarget='aws-credentials-form' onClick={handleSubmit}>
        <Trans>Submit</Trans>
      </Button>
    </>
  )
}
